import React from "react";

export const PrivacyPolicy = () => {
    return (
        <div style={{
            maxWidth: '800px',
            margin: '0 auto',
            padding: '40px 20px',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            lineHeight: '1.6',
            color: '#333',
            backgroundColor: '#fff'
        }}>
            {/* Header */}
            <div style={{
                textAlign: 'center',
                marginBottom: '50px',
                paddingBottom: '30px',
                borderBottom: '3px solid #e1e5e9'
            }}>
                <h1 style={{
                    fontSize: '42px',
                    fontWeight: '700',
                    color: '#1a1a1a',
                    margin: '0 0 10px 0'
                }}>Privacy Policy</h1>
                <p style={{
                    fontSize: '14px',
                    color: '#666',
                    backgroundColor: '#f8f9fa',
                    padding: '8px 16px',
                    borderRadius: '20px',
                    display: 'inline-block',
                    margin: '0'
                }}>Last updated: October 23, 2026</p>
            </div>

            {/* Introduction */}
            <div style={{
                backgroundColor: '#f0f8ff',
                padding: '25px',
                borderRadius: '8px',
                marginBottom: '40px',
                border: '1px solid #d6ebff'
            }}>
                <p style={{ margin: '0 0 15px 0', fontSize: '16px' }}>
                    This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
                </p>
                <p style={{ margin: '0', fontSize: '16px' }}>
                    We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.
                </p>
            </div>

            {/* Quick Navigation */}
            <div style={{
                backgroundColor: '#f8f9fa',
                padding: '20px',
                borderRadius: '8px',
                marginBottom: '40px'
            }}>
                <h3 style={{ margin: '0 0 15px 0', color: '#333', fontSize: '18px' }}>Quick Navigation</h3>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '8px' }}>
                    {/* `id` is explicit rather than derived from the array index: the
                        cookies section was added later and slotting it in by index
                        would have renumbered every anchor below it. */}
                    {[
                        { label: 'Definitions', id: 'section-0' },
                        { label: 'Data Collection', id: 'section-1' },
                        { label: 'Cookies & Analytics', id: 'section-cookies' },
                        { label: 'Data Usage', id: 'section-2' },
                        { label: 'Advertising', id: 'section-advertising' },
                        { label: 'Data Retention', id: 'section-3' },
                        { label: 'Data Transfer', id: 'section-4' },
                        { label: 'Data Disclosure', id: 'section-5' },
                        { label: 'Security', id: 'section-6' },
                        { label: 'Children\'s Privacy', id: 'section-7' },
                        { label: 'Contact', id: 'section-8' },
                    ].map(({ label, id }, i) => (
                        <a key={i} href={`#${id}`} style={{
                            color: '#0066cc',
                            textDecoration: 'none',
                            padding: '4px 0',
                            fontSize: '14px'
                        }} onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                            onMouseOut={(e) => e.target.style.textDecoration = 'none'}>
                            {label}
                        </a>
                    ))}
                </div>
            </div>

            {/* Content */}
            <div style={{ fontSize: '15px' }}>

                {/* Definitions Section */}
                <section id="section-0" style={{ marginBottom: '50px' }}>
                    <h2 style={{
                        fontSize: '28px',
                        fontWeight: '600',
                        color: '#1a1a1a',
                        marginBottom: '25px',
                        paddingBottom: '10px',
                        borderBottom: '2px solid #e1e5e9'
                    }}>Interpretation and Definitions</h2>

                    <div style={{ marginBottom: '30px' }}>
                        <h3 style={{ fontSize: '20px', fontWeight: '500', color: '#333', marginBottom: '15px' }}>
                            Interpretation
                        </h3>
                        <p>The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</p>
                    </div>

                    <div>
                        <h3 style={{ fontSize: '20px', fontWeight: '500', color: '#333', marginBottom: '20px' }}>
                            Definitions
                        </h3>
                        <p style={{ marginBottom: '20px' }}>For the purposes of this Privacy Policy:</p>

                        <div style={{ display: 'grid', gap: '15px' }}>
                            {[
                                { term: "Account", def: "means a unique account created for You to access our Service or parts of our Service." },
                                { term: "Affiliate", def: "means an entity that controls, is controlled by or is under common control with a party, where \"control\" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority." },
                                { term: "Application", def: "refers to Parallel Poker: Texas Holdem, the software program provided by the Company." },
                                { term: "Company", def: "(referred to as either \"the Company\", \"We\", \"Us\" or \"Our\" in this Agreement) refers to Duplicate Poker Limited, 18 Temple Fortune Lane." },
                                { term: "Country", def: "refers to: United Kingdom" },
                                { term: "Device", def: "means any device that can access the Service such as a computer, a cellphone or a digital tablet." },
                                { term: "Personal Data", def: "is any information that relates to an identified or identifiable individual." },
                                { term: "Service", def: "refers to the Application." },
                                { term: "Service Provider", def: "means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used." },
                                { term: "Usage Data", def: "refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit)." },
                                { term: "You", def: "means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable." }
                            ].map((item, index) => (
                                <div key={index} style={{
                                    backgroundColor: '#f8f9fa',
                                    padding: '15px',
                                    borderRadius: '6px',
                                    borderLeft: '4px solid #0066cc'
                                }}>
                                    <div style={{ fontWeight: '600', color: '#1a1a1a', marginBottom: '5px' }}>
                                        {item.term}
                                    </div>
                                    <div style={{ color: '#555', fontSize: '14px' }}>
                                        {item.def}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Data Collection Section */}
                <section id="section-1" style={{ marginBottom: '50px' }}>
                    <h2 style={{
                        fontSize: '28px',
                        fontWeight: '600',
                        color: '#1a1a1a',
                        marginBottom: '25px',
                        paddingBottom: '10px',
                        borderBottom: '2px solid #e1e5e9'
                    }}>Collecting and Using Your Personal Data</h2>

                    <h3 style={{ fontSize: '22px', fontWeight: '500', color: '#333', marginBottom: '20px' }}>
                        Types of Data Collected
                    </h3>

                    <div style={{ marginBottom: '30px' }}>
                        <h4 style={{
                            fontSize: '18px',
                            fontWeight: '500',
                            color: '#0066cc',
                            marginBottom: '15px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <span style={{
                                width: '8px',
                                height: '8px',
                                backgroundColor: '#0066cc',
                                borderRadius: '50%',
                                marginRight: '10px'
                            }}></span>
                            Personal Data
                        </h4>
                        <p style={{ marginBottom: '15px' }}>
                            While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:
                        </p>
                        <div style={{
                            backgroundColor: '#e8f4fd',
                            padding: '15px',
                            borderRadius: '6px',
                            marginBottom: '20px'
                        }}>
                            <ul style={{ margin: '0', paddingLeft: '20px' }}>
                                <li style={{ marginBottom: '5px' }}>Email address</li>
                                <li>Usage Data</li>
                            </ul>
                        </div>
                    </div>

                    <div style={{ marginBottom: '30px' }}>
                        <h4 style={{
                            fontSize: '18px',
                            fontWeight: '500',
                            color: '#28a745',
                            marginBottom: '15px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <span style={{
                                width: '8px',
                                height: '8px',
                                backgroundColor: '#28a745',
                                borderRadius: '50%',
                                marginRight: '10px'
                            }}></span>
                            Usage Data
                        </h4>
                        <div style={{ color: '#555' }}>
                            <p style={{ marginBottom: '15px' }}>Usage Data is collected automatically when using the Service.</p>
                            <p style={{ marginBottom: '15px' }}>Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</p>
                            <p style={{ marginBottom: '15px' }}>When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.</p>
                            <p>We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.</p>
                        </div>
                    </div>

                    <div style={{ marginBottom: '30px' }}>
                        <h4 style={{
                            fontSize: '18px',
                            fontWeight: '500',
                            color: '#6f42c1',
                            marginBottom: '15px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <span style={{
                                width: '8px',
                                height: '8px',
                                backgroundColor: '#6f42c1',
                                borderRadius: '50%',
                                marginRight: '10px'
                            }}></span>
                            Information Collected while Using the Application
                        </h4>
                        <div style={{
                            backgroundColor: '#f8f0ff',
                            padding: '20px',
                            borderRadius: '6px',
                            border: '1px solid #e8d5ff'
                        }}>
                            <p style={{ marginBottom: '15px' }}>
                                While using Our Application, in order to provide features of Our Application, We may collect, with Your prior permission:
                            </p>
                            <ul style={{ marginBottom: '15px', paddingLeft: '20px' }}>
                                <li>Pictures and other information from your Device's camera and photo library</li>
                            </ul>
                            <p style={{ marginBottom: '10px', fontSize: '14px' }}>
                                We use this information to provide features of Our Service, to improve and customize Our Service. The information may be uploaded to the Company's servers and/or a Service Provider's server or it may be simply stored on Your device.
                            </p>
                            <p style={{ margin: '0', fontSize: '14px', fontStyle: 'italic' }}>
                                You can enable or disable access to this information at any time, through Your Device settings.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Cookies and Analytics Section */}
                <section id="section-cookies" style={{ marginBottom: '50px' }}>
                    <h2 style={{
                        fontSize: '28px',
                        fontWeight: '600',
                        color: '#1a1a1a',
                        marginBottom: '25px',
                        paddingBottom: '10px',
                        borderBottom: '2px solid #e1e5e9'
                    }}>Cookies and Analytics on This Website</h2>

                    <p style={{ marginBottom: '20px' }}>
                        This section applies to this website (parallelpoker.com) specifically, rather than to the Application.
                    </p>

                    <div style={{
                        backgroundColor: '#f0f8ff',
                        padding: '20px',
                        borderRadius: '8px',
                        border: '1px solid #d6ebff',
                        marginBottom: '30px'
                    }}>
                        <p style={{ margin: '0', fontSize: '15px' }}>
                            <strong>In short:</strong> we use Google Analytics to understand how people find and use this
                            website. Analytics cookies are only placed on Your device if You accept them. You can change
                            Your mind at any time using the <strong>Cookie Settings</strong> link in the footer of every page.
                        </p>
                    </div>

                    <div style={{ marginBottom: '30px' }}>
                        <h3 style={{ fontSize: '20px', fontWeight: '500', color: '#333', marginBottom: '15px' }}>
                            What We Use
                        </h3>
                        <p style={{ marginBottom: '15px' }}>
                            We use Google Analytics 4, a web analytics service provided by Google Ireland Limited
                            ("Google"). It tells Us how many people visit the site, which pages they read, roughly where in
                            the world they are, what kind of device they use, how they found Us, and whether they go on to
                            visit the App Store or Google Play. We use this to improve the site. On this website, We do not
                            use Google Analytics' advertising, remarketing or ad-personalisation features, and We do not
                            sell Your data. Advertisements in the Application are covered separately under Advertising below.
                        </p>
                    </div>

                    <div style={{ marginBottom: '30px' }}>
                        <h3 style={{ fontSize: '20px', fontWeight: '500', color: '#333', marginBottom: '15px' }}>
                            If You Accept
                        </h3>
                        <p style={{ marginBottom: '15px' }}>
                            Google Analytics sets the following first-party cookies on Your device:
                        </p>
                        <div style={{
                            backgroundColor: '#f8f9fa',
                            padding: '20px',
                            borderRadius: '6px',
                            marginBottom: '15px'
                        }}>
                            <ul style={{ margin: '0', paddingLeft: '20px' }}>
                                <li style={{ marginBottom: '10px' }}>
                                    <strong>_ga</strong> — distinguishes one visitor from another so repeat visits are not
                                    counted as new people. Expires after 2 years.
                                </li>
                                <li>
                                    <strong>_ga_&lt;container-id&gt;</strong> — maintains the state of Your current visit.
                                    Expires after 2 years.
                                </li>
                            </ul>
                        </div>
                        <p style={{ marginBottom: '0' }}>
                            The lawful basis for this processing is Your consent.
                        </p>
                    </div>

                    <div style={{ marginBottom: '30px' }}>
                        <h3 style={{ fontSize: '20px', fontWeight: '500', color: '#333', marginBottom: '15px' }}>
                            If You Decline
                        </h3>
                        <p style={{ marginBottom: '15px' }}>
                            <strong>No cookies are set and no identifier is stored on Your device.</strong> We use Google's
                            Consent Mode, which means Google Analytics remains loaded but runs in a restricted state.
                        </p>
                        <p style={{ marginBottom: '15px' }}>
                            In that state it still sends Google an anonymous signal that a page was viewed. That signal
                            contains no cookie and no identifier, and it cannot be linked to You or to any of Your other
                            visits. It contains the page address, the page You arrived from, and Your browser and device
                            type. Google uses these signals only in aggregate, to estimate overall traffic. We consider this
                            to be processing under Our legitimate interest in measuring the overall reach of Our website,
                            and it involves no storage of, or access to, information on Your device.
                        </p>
                        <p style={{ marginBottom: '0' }}>
                            If You would rather not send even that signal, You can use Google's official{' '}
                            <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer"
                                style={{ color: '#0066cc' }}>
                                browser opt-out add-on
                            </a>, or block the domain in Your browser or an extension.
                        </p>
                    </div>

                    <div style={{ marginBottom: '30px' }}>
                        <h3 style={{ fontSize: '20px', fontWeight: '500', color: '#333', marginBottom: '15px' }}>
                            Storage That Is Always Used
                        </h3>
                        <p style={{ marginBottom: '0' }}>
                            Whichever choice You make, We store that choice itself in Your browser's local storage, under
                            the key <strong>pp_cookie_consent</strong>. This is strictly necessary — without it We would
                            have to ask You again on every page. It contains only Your answer and the date You gave it, it
                            never leaves Your device, and it expires after 12 months, at which point We will ask again.
                        </p>
                    </div>

                    <div style={{ marginBottom: '30px' }}>
                        <h3 style={{ fontSize: '20px', fontWeight: '500', color: '#333', marginBottom: '15px' }}>
                            IP Addresses and International Transfers
                        </h3>
                        <p style={{ marginBottom: '15px' }}>
                            Google Analytics 4 does not log or store IP addresses. Your IP address is used momentarily to
                            derive an approximate location (typically country or city level) and is then discarded.
                        </p>
                        <p style={{ marginBottom: '0' }}>
                            Google may process this data outside the United Kingdom and the European Economic Area. Where it
                            does, the transfer is covered by the EU-US Data Privacy Framework and by Standard Contractual
                            Clauses. Google's own handling of this data is described in the{' '}
                            <a href="https://business.safety.google/privacy/" target="_blank" rel="noopener noreferrer"
                                style={{ color: '#0066cc' }}>
                                Google Business Data Responsibility notice
                            </a>.
                        </p>
                    </div>

                    <div style={{
                        backgroundColor: '#f0fff4',
                        padding: '20px',
                        borderRadius: '8px',
                        border: '1px solid #c6f6d5'
                    }}>
                        <h3 style={{ fontSize: '20px', fontWeight: '500', color: '#333', marginTop: '0', marginBottom: '15px' }}>
                            Changing Your Mind
                        </h3>
                        <p style={{ margin: '0' }}>
                            Use the <strong>Cookie Settings</strong> link in the footer of any page. It takes effect
                            immediately and brings the consent banner back so You can choose again. You can also delete
                            cookies at any time through Your browser's settings.
                        </p>
                    </div>
                </section>

                {/* Data Usage Section */}
                <section id="section-2" style={{ marginBottom: '50px' }}>
                    <h3 style={{ fontSize: '22px', fontWeight: '500', color: '#333', marginBottom: '20px' }}>
                        Use of Your Personal Data
                    </h3>
                    <p style={{ marginBottom: '20px' }}>The Company may use Personal Data for the following purposes:</p>

                    <div style={{ display: 'grid', gap: '12px', marginBottom: '25px' }}>
                        {[
                            { title: "To provide and maintain our Service", desc: "including to monitor the usage of our Service." },
                            { title: "To manage Your Account", desc: "to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user." },
                            { title: "For the performance of a contract", desc: "the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service." },
                            { title: "To contact You", desc: "To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation." },
                            { title: "To provide You", desc: "with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information." },
                            { title: "To manage Your requests", desc: "To attend and manage Your requests to Us." },
                            { title: "To show advertising", desc: "to show advertisements in the free version of the Application, measure how they perform and prevent advertising fraud, as described under Advertising below." },
                            { title: "For business transfers", desc: "We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred." },
                            { title: "For other purposes", desc: "We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience." }
                        ].map((item, index) => (
                            <div key={index} style={{
                                backgroundColor: '#f8f9fa',
                                padding: '15px',
                                borderRadius: '6px'
                            }}>
                                <div style={{ fontWeight: '600', color: '#1a1a1a', marginBottom: '8px' }}>
                                    {item.title}
                                </div>
                                <div style={{ color: '#555', fontSize: '14px' }}>
                                    {item.desc}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div style={{
                        backgroundColor: '#fff3cd',
                        padding: '20px',
                        borderRadius: '6px',
                        border: '1px solid #ffeaa7',
                        borderLeft: '4px solid #fdcb6e'
                    }}>
                        <h4 style={{ fontWeight: '600', color: '#1a1a1a', marginBottom: '15px', fontSize: '16px' }}>
                            Information Sharing
                        </h4>
                        <p style={{ marginBottom: '15px', fontSize: '14px' }}>We may share Your personal information in the following situations:</p>
                        <div style={{ fontSize: '14px', lineHeight: '1.5' }}>
                            <p style={{ marginBottom: '8px' }}><strong>With Service Providers:</strong> We may share Your personal information with Service Providers to monitor and analyze the use of our Service, to contact You.</p>
                            <p style={{ marginBottom: '8px' }}><strong>With advertising partners:</strong> Google AdMob and the advertising partners listed in our consent form receive the information described under Advertising below, when advertisements are requested or shown in the Application.</p>
                            <p style={{ marginBottom: '8px' }}><strong>For business transfers:</strong> We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company.</p>
                            <p style={{ marginBottom: '8px' }}><strong>With Affiliates:</strong> We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy.</p>
                            <p style={{ marginBottom: '8px' }}><strong>With business partners:</strong> We may share Your information with Our business partners to offer You certain products, services or promotions.</p>
                            <p style={{ marginBottom: '8px' }}><strong>With other users:</strong> when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside.</p>
                            <p style={{ margin: '0' }}><strong>With Your consent:</strong> We may disclose Your personal information for any other purpose with Your consent.</p>
                        </div>
                    </div>
                </section>

                {/* Advertising Section */}
                <section id="section-advertising" style={{ marginBottom: '50px' }}>
                    <h2 style={{
                        fontSize: '28px',
                        fontWeight: '600',
                        color: '#1a1a1a',
                        marginBottom: '25px',
                        paddingBottom: '10px',
                        borderBottom: '2px solid #e1e5e9'
                    }}>Advertising</h2>

                    <p style={{ marginBottom: '15px' }}>
                        The free version of the Application may show advertisements. Players with a Premium or Unlimited Play subscription do not see advertisements. Advertisements are provided by Google AdMob, an advertising service of Google, together with the advertising partners listed in our consent form.
                    </p>

                    <h4 style={{ fontSize: '18px', fontWeight: '500', color: '#333', marginBottom: '10px' }}>What is collected</h4>
                    <p style={{ marginBottom: '10px' }}>When an advertisement is requested or shown, Google's advertising software in the Application collects:</p>
                    <ul style={{ marginBottom: '15px', paddingLeft: '20px', color: '#555' }}>
                        <li style={{ marginBottom: '5px' }}>Your Device's IP address, which may be used to estimate its general location</li>
                        <li style={{ marginBottom: '5px' }}>Device identifiers: on Android, Your advertising ID and app set ID; on iOS, an identifier limited to Our own apps. The Application does not ask for permission to track You and does not use Your iOS advertising identifier (IDFA).</li>
                        <li style={{ marginBottom: '5px' }}>Information about how You use the Application and interact with advertisements, such as app launches, taps and the advertisements You have seen</li>
                        <li>Diagnostic information about the performance of the Application and the advertising software</li>
                    </ul>
                    <p style={{ marginBottom: '20px' }}>
                        We also record, through Our analytics and subscription Service Providers, when advertisements are requested, shown and closed and the advertising revenue they generate, together with Your Account, to understand how advertising affects the Service.
                    </p>

                    <h4 style={{ fontSize: '18px', fontWeight: '500', color: '#333', marginBottom: '10px' }}>Why it is used</h4>
                    <p style={{ marginBottom: '20px' }}>
                        To select and show advertisements, limit how often You see the same advertisement, measure how advertisements perform, and detect and prevent fraud and abuse. Only if You agree is it also used to show You personalised advertisements based on Your interests.
                    </p>

                    <div style={{
                        backgroundColor: '#fff3cd',
                        padding: '20px',
                        borderRadius: '6px',
                        border: '1px solid #ffeaa7',
                        borderLeft: '4px solid #fdcb6e',
                        marginBottom: '20px'
                    }}>
                        <h4 style={{ fontWeight: '600', color: '#1a1a1a', marginBottom: '15px', fontSize: '16px' }}>
                            Your consent (United Kingdom, European Economic Area and Switzerland)
                        </h4>
                        <div style={{ fontSize: '14px', lineHeight: '1.5' }}>
                            <p style={{ marginBottom: '8px' }}>Before showing advertisements, We ask for Your consent using Google's consent management tool. You can agree, refuse, or choose individual purposes and partners.</p>
                            <p style={{ marginBottom: '8px' }}>If You refuse, Google may still show non-personalised or limited advertisements, which use Your information only for purposes that do not need Your consent, such as preventing fraud.</p>
                            <p style={{ marginBottom: '8px' }}>You can change or withdraw Your choice at any time in the Application under <strong>Settings → Privacy Choices</strong>. Withdrawing consent does not affect advertising shown before You withdrew it.</p>
                            <p style={{ margin: '0' }}>We rely on Your consent for personalised advertising and for storing or accessing information on Your Device for advertising, and on Our legitimate interests in funding the free version of the Service, measuring advertising and preventing fraud.</p>
                        </div>
                    </div>

                    <h4 style={{ fontSize: '18px', fontWeight: '500', color: '#333', marginBottom: '10px' }}>Other regions</h4>
                    <p style={{ marginBottom: '20px' }}>
                        On Android, You can reset Your advertising ID or opt out of personalised advertising in Your Device's settings (Settings → Google → Ads, or Settings → Privacy → Ads, depending on Your Device).
                    </p>

                    <h4 style={{ fontSize: '18px', fontWeight: '500', color: '#333', marginBottom: '10px' }}>More information</h4>
                    <ul style={{ paddingLeft: '20px', color: '#555' }}>
                        <li style={{ marginBottom: '5px' }}>
                            <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer" style={{ color: '#0066cc' }}>How Google uses information from sites or apps that use its services</a>
                        </li>
                        <li>
                            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: '#0066cc' }}>Google's Privacy Policy</a>
                        </li>
                    </ul>
                </section>

                {/* Remaining sections with clean styling */}
                {[
                    {
                        id: 'section-3',
                        title: 'Retention of Your Personal Data',
                        content: (
                            <div>
                                <p style={{ marginBottom: '15px' }}>The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.</p>
                                <p>The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods.</p>
                            </div>
                        )
                    },
                    {
                        id: 'section-4',
                        title: 'Transfer of Your Personal Data',
                        content: (
                            <div>
                                <p style={{ marginBottom: '15px' }}>Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction.</p>
                                <p style={{ marginBottom: '15px' }}>Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer.</p>
                                <p style={{ marginBottom: '15px' }}>Google, which provides the advertisements in the Application, may process the information described under Advertising in the United States and other countries outside the United Kingdom and the European Economic Area. Google relies on safeguards recognised under UK and EU data protection law for these transfers, such as its participation in the EU-U.S. Data Privacy Framework (including its UK extension) and standard contractual clauses.</p>
                                <p>The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information.</p>
                            </div>
                        )
                    },
                    {
                        id: 'section-5',
                        title: 'Disclosure of Your Personal Data',
                        content: (
                            <div>
                                <div style={{ marginBottom: '25px' }}>
                                    <h4 style={{ fontSize: '18px', fontWeight: '500', marginBottom: '10px' }}>Business Transactions</h4>
                                    <p>If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.</p>
                                </div>
                                <div style={{ marginBottom: '25px' }}>
                                    <h4 style={{ fontSize: '18px', fontWeight: '500', marginBottom: '10px' }}>Law Enforcement</h4>
                                    <p>Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).</p>
                                </div>
                                <div>
                                    <h4 style={{ fontSize: '18px', fontWeight: '500', marginBottom: '10px' }}>Other Legal Requirements</h4>
                                    <p style={{ marginBottom: '15px' }}>The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:</p>
                                    <ul style={{ paddingLeft: '20px', color: '#555' }}>
                                        <li style={{ marginBottom: '5px' }}>Comply with a legal obligation</li>
                                        <li style={{ marginBottom: '5px' }}>Protect and defend the rights or property of the Company</li>
                                        <li style={{ marginBottom: '5px' }}>Prevent or investigate possible wrongdoing in connection with the Service</li>
                                        <li style={{ marginBottom: '5px' }}>Protect the personal safety of Users of the Service or the public</li>
                                        <li>Protect against legal liability</li>
                                    </ul>
                                </div>
                            </div>
                        )
                    },
                    {
                        id: 'section-6',
                        title: 'Security of Your Personal Data',
                        content: (
                            <div style={{
                                backgroundColor: '#e3f2fd',
                                padding: '20px',
                                borderRadius: '6px',
                                border: '1px solid #bbdefb'
                            }}>
                                <p style={{ margin: '0' }}>
                                    The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.
                                </p>
                            </div>
                        )
                    },
                    {
                        id: 'section-7',
                        title: 'Children\'s Privacy',
                        content: (
                            <div>
                                <p style={{ marginBottom: '15px' }}>Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers.</p>
                                <p>If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent's consent before We collect and use that information.</p>
                            </div>
                        )
                    }
                ].map((section) => (
                    <section key={section.id} id={section.id} style={{ marginBottom: '50px' }}>
                        <h2 style={{
                            fontSize: '28px',
                            fontWeight: '600',
                            color: '#1a1a1a',
                            marginBottom: '25px',
                            paddingBottom: '10px',
                            borderBottom: '2px solid #e1e5e9'
                        }}>{section.title}</h2>
                        {section.content}
                    </section>
                ))}

                {/* Contact Section */}
                <section id="section-8" style={{ marginBottom: '50px' }}>
                    <h2 style={{
                        fontSize: '28px',
                        fontWeight: '600',
                        color: '#1a1a1a',
                        marginBottom: '25px',
                        paddingBottom: '10px',
                        borderBottom: '2px solid #e1e5e9'
                    }}>Contact Us</h2>
                    <div style={{
                        backgroundColor: '#e8f5e8',
                        padding: '25px',
                        borderRadius: '8px',
                        border: '1px solid #c8e6c9',
                        textAlign: 'center'
                    }}>
                        <p style={{ marginBottom: '20px', fontSize: '16px' }}>
                            If you have any questions about this Privacy Policy, You can contact us:
                        </p>
                        <div style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            backgroundColor: '#fff',
                            padding: '12px 20px',
                            borderRadius: '25px',
                            border: '1px solid #4caf50'
                        }}>
                            <span style={{ fontSize: '18px', marginRight: '8px' }}>✉️</span>
                            <a href="mailto:info@parallelpoker.com" style={{
                                color: '#2e7d32',
                                textDecoration: 'none',
                                fontWeight: '500',
                                fontSize: '16px'
                            }} onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                                onMouseOut={(e) => e.target.style.textDecoration = 'none'}>
                                info@parallelpoker.com
                            </a>
                        </div>
                    </div>
                </section>

            </div>
        </div>
    );
};